<template>
  <div class="w-258px h-156px bor-12px b-EFEFEF p-r o-h">
    <div class="w-100 h-22px b-D8D8D8 t-31px p-a">
    </div>
  </div>
</template>

<script>
export default {
  name: 'guideC',
  extends: {},
  props: {},
  data(){
    return{};
  },
  components: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate(){},
  mounted(){}
}
</script>
